import React from "react";
import { noop } from "utils/General";
const Logo = ({
  logoImageUrl,
  logoImageAltText,
  size = "80px",
  onClick = noop,
  style = {},
  isOnNavBar = false
}) =>
  logoImageUrl ? (
    <div
      style={{
        width: isOnNavBar ? size : "auto",
        height: isOnNavBar ? "unset" : "100px",
        minHeight: isOnNavBar ? size : "100px",
        backgroundColor: "#FFFFFF",
        ...style
      }}
      tabIndex={0}
      onClick={onClick}
    >
      <img
        alt={logoImageAltText}
        src={logoImageUrl}
        style={
          isOnNavBar
            ? { maxWidth: "100%" }
            : {
                height: "100%",
                width: "100%"
              }
        }
      />
    </div>
  ) : null;

export default Logo;
